import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

const ACTIONS = {
  TRAINING_MODE_ON: "on_training_mode",
  RESET_VALUES: "reset_values",
  SHOW_BONUS_DETAILS: "show_bonus_details",
  SHOW_PERSONAL_BONUS: "show_personal_bonus_calculation",
  SHOW_DIFFERENTIAL_BONUS: "show_differential_bonus_calculation",
  SHOW_CSI_CALCULATION: "show_csi_calculation",
  SHOW_BFI_CALCULATION: "show_bfi_calculation",
  SHOW_BBI_CALCULATION: "show_bbi_calculation",
  HIDE_BONUS_DETAILS: "hide_bonus_details",
  TRAINING_MODE_OFF: "off_training_mode",
  OPEN_INFO_PANEL: "open_info_panel",
  BRONZE_FOUNDATION_TARGET: "bronze_foundation_target",
  BRONZE_BUILDER_TARGET: "bronze_builder_target",
  RESET_GPV_VALUE: "reset_gpv_value",
  REMOVE_ABO_LEG: "remove_abo_leg",
  ADD_ABO_LEG: "add_abo_leg",
} as const;

/**
 * Utility function to track user actions.
 * @param {string} section - The section where the action takes place.
 * @param {string} action - The action being tracked.
 * @param {string} [category=TEALIUM.CATEGORY.ECV2] - The category of the action.
 */
const trackUtil = (section: string, action: string, category: string = TEALIUM.CATEGORY.ECV2) => {
  track(TEALIUM.U_TAG_METHOD.LINK, TEALIUM.EVENT_NAME.CLICK_ACTION, section, category, "", action);
};

// Tracks EC Page
export const trackECPage = () =>
  track(TEALIUM.U_TAG_METHOD.VIEW, "", "", TEALIUM.CATEGORY.ECV2, TEALIUM.CATEGORY.ECV2, "");

export const trainingModeOnTrack = () => trackUtil(TEALIUM.SECTION.EC, ACTIONS.TRAINING_MODE_ON);

export const trainingModeOffTrack = () => trackUtil(TEALIUM.SECTION.EC, ACTIONS.TRAINING_MODE_OFF);

export const resetValuesTrack = () => trackUtil(TEALIUM.SECTION.KPI, ACTIONS.RESET_VALUES);

export const showBonusDetailsTrack = () => trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.SHOW_BONUS_DETAILS);

export const showPersonalBonusCalculationTrack = () =>
  trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.SHOW_PERSONAL_BONUS);

export const showDifferentialBonusCalculationTrack = () =>
  trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.SHOW_DIFFERENTIAL_BONUS);

export const showCSICalculationTrack = () => trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.SHOW_CSI_CALCULATION);

export const showBFICalculationTrack = () => trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.SHOW_BFI_CALCULATION);

export const showBBICalculationTrack = () => trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.SHOW_BBI_CALCULATION);

export const hideBonusDetailsTrack = () => trackUtil(TEALIUM.SECTION.BONUS_DETAILS, ACTIONS.HIDE_BONUS_DETAILS);

export const openECInfoPanelTrack = () => trackUtil(TEALIUM.SECTION.EC, ACTIONS.OPEN_INFO_PANEL);

export const openABOLegsInfoPanelTrack = () => trackUtil(TEALIUM.SECTION.ABO_LEGS, ACTIONS.OPEN_INFO_PANEL);

export const bronzeFoundationTargetTrack = () => trackUtil(TEALIUM.SECTION.ABO_LEGS, ACTIONS.BRONZE_FOUNDATION_TARGET);

export const bronzeBuilderTargetTrack = () => trackUtil(TEALIUM.SECTION.ABO_LEGS, ACTIONS.BRONZE_BUILDER_TARGET);

export const resetGPVTrack = () => trackUtil(TEALIUM.SECTION.ABO_LEGS, ACTIONS.RESET_GPV_VALUE);

export const removeABOLegTrack = () => trackUtil(TEALIUM.SECTION.ABO_LEGS, ACTIONS.REMOVE_ABO_LEG);

export const addABOLegTrack = () => trackUtil(TEALIUM.SECTION.ABO_LEGS, ACTIONS.ADD_ABO_LEG);
